import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";

const CropFamilyForm = ({ onSubmit, onCancel, initialData = null }) => {
  const [formState, setFormState] = useState({
    name: "",
    description: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormState({
        name: initialData.name || "",
        description: initialData.description || "",
      });
    }
  }, [initialData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formState);
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        {initialData ? "Edit Crop Family" : "Add Crop Family"}
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Name"
          name="name"
          value={formState.name}
          onChange={handleInputChange}
          margin="normal"
          size="small"
        />
        <TextField
          fullWidth
          label="Description"
          name="description"
          value={formState.description}
          onChange={handleInputChange}
          margin="normal"
          multiline
          rows={3}
          size="small"
        />
        <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}>
          <Button variant="outlined" onClick={onCancel} className="vintage-button">
            Cancel
          </Button>
          <Button variant="outlined" type="submit" className="vintage-button">
            Save
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default CropFamilyForm;
